import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  locales: ['tr', 'en', 'de', 'ru'],
  defaultLocale: 'tr',
  localePrefix: 'as-needed',
  localeDetection: false,
  pathnames: {
    '/': '/',
    '/hakkimizda': {
      tr: '/hakkimizda',
      en: '/about-us',
      de: '/ueber-uns',
      ru: '/o-nas',
    },
    '/iletisim': {
      tr: '/iletisim',
      en: '/contact',
      de: '/kontakt',
      ru: '/kontakty',
    },
    '/hizmetlerimiz': {
      tr: '/hizmetlerimiz',
      en: '/services',
      de: '/leistungen',
      ru: '/uslugi',
    },
    '/blog': {
      tr: '/blog',
      en: '/blog',
      de: '/blog',
      ru: '/blog',
    },
    '/blog/[slug]': {
      tr: '/blog/[slug]',
      en: '/blog/[slug]',
      de: '/blog/[slug]',
      ru: '/blog/[slug]',
    },
    '/genitalestetik': {
      tr: '/genital-estetik',
      en: '/genital-aesthetics',
      de: '/genitale-aesthetik',
      ru: '/genitalnaya-estetika',
    },
    '/gizlilik-politikasi': {
      tr: '/gizlilik-politikasi',
      en: '/privacy-policy',
      de: '/datenschutzerklaerung',
      ru: '/politika-konfidencialnosti',
    },
    '/kullanim-sartlari': {
      tr: '/kullanim-sartlari',
      en: '/terms-of-use',
      de: '/nutzungsbedingungen',
      ru: '/usloviya-ispolzovaniya',
    },
    '/veri-kullanimi-cerezler': {
      tr: '/veri-kullanimi-cerezler',
      en: '/data-usage-cookies',
      de: '/datennutzung-cookies',
      ru: '/ispolzovanie-dannyh-cookies',
    },
    '/tesekkurler': {
      tr: '/tesekkurler',
      en: '/thank-you',
      de: '/vielen-dank',
      ru: '/spasibo',
    },
    '/[slug]': '/[slug]',
  },
});

export type Locale = (typeof routing.locales)[number];

export const STRAPI_LOCALE_MAP: Record<Locale, string> = {
  tr: 'tr-TR',
  en: 'en',
  de: 'de',
  ru: 'ru',
};

export function toStrapiLocale(locale: string): string {
  return STRAPI_LOCALE_MAP[locale as Locale] || 'tr-TR';
}
